import React from 'react';

type Props = {
    message    : any
    close     ?: callback
    fadeTime   : number
}

export default function ConnectionError(props:Props) {

    const classes = Classes("notification","h-100-percent", "connection-error")

    return (
        <div className={Classes(classes)} style={{transition: "opacity " + props.fadeTime + "s"}}>

            <div className="flex-row-left-center">
                <div className="icon-circle">
                    <div className="i5-plug ui5-color-txt-white"/>
                </div>
                <div className="message ui5-txt-less-important m-l-10">
                    {props.message}
                </div>
            </div>
            <div className="close i5-delete" onClick={props.close}/>
        </div>

)

}
